// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t-t5","controls":"styles_controls__1FLlX","charLimit":"styles_charLimit__3HdrF","input":"styles_input__1DIhs","send":"styles_send__2sWf3"};